module.exports = __webpack_public_path__ + "img/tree-06-c-leaves.d0c38f30.png";